import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Axios from "axios";
import document from "../Assets/document.svg";
import ResponseModal from "./response";
import Typography from "@material-ui/core/Typography";
import * as moment from "moment";
import { Grid } from "@material-ui/core";
import Styles from "../index.module.scss";
import UrlLinks from "../../../UrlLinks";
import Download from "../Assets/Group 3238.svg";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    borderBottom: "unset",
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {
  const {
    openOnboardingModal,
    setOpenOnboardingModal,
    showToast,
    updateMyData,
  } = props;
  const [excel, setExcel] = useState(null);
  const [openResponseModal, setOpenResponseModal] = useState(false);
  const [name, setName] = useState("");
  const [excelError, setExcelError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [invalidData, setInvalidData] = useState();
  const [responseData, setResponseData] = useState();
  const [closeFile, setCloseFile] = useState(true);

  const handleClose = () => {
    setOpenOnboardingModal(false);
  };

  const handleCloseFile = () => {
    setName("");
    setCloseFile(true);
  };

  const handleUpload = (event) => {
    const fileExtension = event.target.files[0].name.split(".").slice(-1)[0];
    const fileName = event.target.files[0].name;

    if (
      fileExtension.toLowerCase() === "xlsx" ||
      fileExtension.toLowerCase() === "xls"
    ) {
      setName(fileName);
      setExcel(event.target.files[0]);
      setExcelError(false);
      setCloseFile(false);
    } else {
      setExcelError(true);
      setExcel(null);
      setName("");
    }
    setResponseData();
    event.target.value = null;
  };

  let newOnboardingExcel = "/payment_excel_upload_template.xlsx";

  const createInvalidData = (records) => {
    if (records.response.length > 1) {
      let list = [];
      records.response.map((record) => {
        if (record.hasOwnProperty("Worker_payment_detail")) {
          if (record.Worker_payment_detail.status !== "uploaded") {
            list.push({
              "Project Name": record.Worker_payment_detail.projectName || "",
              "Client Name": record.Worker_payment_detail.invoiceFor || "",
              "Client ID": record.Worker_payment_detail.casperId || "",
              "OkayGo ID": record.Worker_payment_detail.okaygoId || "",
              Name: record.Worker_payment_detail.name
                ? "" + record.Worker_payment_detail.name
                : "",
              "Contact No": record.Worker_payment_detail.phoneNumber || "",
              "Bill from":
                moment(record.Worker_payment_detail.billFrom).format(
                  "DD/MM/YYYY"
                ) || "",
              "Bill to":
                moment(record.Worker_payment_detail.billto).format(
                  "DD/MM/YYYY"
                ) || "",
              "Shipment Qty (Delivered) /Completed Task Count": record
                .Worker_payment_detail.shipmentQuantity
                ? "" + record.Worker_payment_detail.shipmentQuantity
                : "",
              "Shipment Allocated": record.shipmentAllocated
                ? "" + record.shipmentAllocated
                : "",
              "Shipment Amount/Base Payout": record.Worker_payment_detail
                .shipmentAmount
                ? "" + record.Worker_payment_detail.shipmentAmount
                : "",
              "MG Contribution": record.Worker_payment_detail.mg_amount
                ? "" + record.Worker_payment_detail.mg_amount
                : "",
              "Surge Charges": record.Worker_payment_detail.surgeCharges
                ? "" + record.Worker_payment_detail.surgeCharges
                : "",
              "Order Incentive":
                record.Worker_payment_detail.orderIncentive || "",
              "Attendance Incentive":
                record.Worker_payment_detail.attendanceIncentive || "",
              Bonus: record.Worker_payment_detail.bonus || "",
              "Long Distance Amount":
                record.Worker_payment_detail.longDistanceAmount || "",
              "Petrol Incentive":
                record.Worker_payment_detail.petrolIncentive || "",
              "Security Deposit Deduction":
                -record.Worker_payment_detail.securityDepositDeduction || "",
              "Reusable Bag/Raincoat/Winter Jacket Deduction":
                -record.Worker_payment_detail.bag_raincoat_jacket_deduction ||
                "",
              "COD Deduction": -record.Worker_payment_detail.codDeduction || "",
              "TDS Deduction": -record.Worker_payment_detail.tdsDeduction || "",
              EMI: -record.Worker_payment_detail.emiDeduction || "",
              "Total Worker Payable Amount": record.Worker_payment_detail
                .totalAmount
                ? "" + record.Worker_payment_detail.totalAmount
                : "",
              "OkayGo Margin (to be input for variable margin cases only)":
                record.Worker_payment_detail.og_margin
                  ? "" + record.Worker_payment_detail.og_margin
                  : "",
              "OkayGo Payout": record.Worker_payment_detail.og_payout
                ? "" + record.Worker_payment_detail.og_payout
                : "",
              "Reason of Failure": record.Worker_payment_detail.reason
                ? "" + record.Worker_payment_detail.reason
                : "",
            });
          }
          return true;
        }
      });
      return list.length > 0 ? list : null;
    }
  };

  const handleExcel = () => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("file", excel);

    Axios.post(
      `${UrlLinks.baseUrl}${
        UrlLinks.workerUrls.uploadPayoutAutomation
      }${localStorage.getItem("userID")}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then((response) => {
        if (response.data) {
          setInvalidData(createInvalidData(response.data));
          const summary = response.data.response.slice(-1)[0];
          setResponseData(summary);
          updateMyData();
          setIsLoading(false);
        } else {
          setResponseData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        showToast("error", error.message);
      });
  };

  useEffect(() => {
    if (responseData) {
      setOpenResponseModal(true);
    }
  }, [responseData]);

  let dialogData = (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={openOnboardingModal}
      className={Styles.onboardingDialog}
      classes={{ paper: Styles.paper }}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <span>Upload Invoice Data</span>
        <a
          style={{ paddingLeft: "1rem", paddingRight: "2.5rem" }}
          href={newOnboardingExcel}
          download
          target="_blank"
          className={Styles.downloadTemplate}
        >
          <span style={{ fontSize: "smaller", color: "#1c4980" }}>
            Download File Template
          </span>
          <img
            style={{ paddingLeft: "1rem", paddingRight: "0.5rem" }}
            src={Download}
            alt="download"
          />
        </a>
      </DialogTitle>
      <DialogContent dividers>
        <Grid item xs={12}>
          <input
            style={{ display: "none" }}
            id="contained-button-file"
            type="file"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={handleUpload}
          />
          <label htmlFor="contained-button-file">
            <Button
              variant="outlined"
              className={Styles.uploadButton}
              component="span"
              startIcon={
                <img src={document} alt={"upload"} style={{ color: "white" }} />
              }
            >
              Browse File
            </Button>
          </label>
        </Grid>
        <Grid item xs={12}>
          <span className={`fontSize13 ${excelError ? "redColor" : ""}`}>
            only .xls and .xlsx are allowed
          </span>
        </Grid>
        <Grid item xs={12} style={{ marginTop: "10px" }}>
          {name && (
            <span className={Styles.fileName}>
              {name.length > 70 ? `${name.substring(0, 69)}...` : `${name}`}
              <span>
                <IconButton
                  aria-label="close"
                  style={{ color: "white", paddingRight: "0" }}
                  onClick={handleCloseFile}
                >
                  <CloseIcon />
                </IconButton>
              </span>
            </span>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        {isLoading ? (
          <span>Please wait... it may take few minutes</span>
        ) : (
          <Button
            variant="contained"
            onClick={handleExcel}
            className={`${!excel ? "disabledButton" : "blueButtonContained"}`}
            disabled={!excel}
          >
            Upload
          </Button>
        )}
      </DialogActions>
      {openResponseModal && (
        <ResponseModal
          openResponseModal={openResponseModal}
          setOpenResponseModal={setOpenResponseModal}
          responseData={responseData}
          setOpenOnboardingModal={setOpenOnboardingModal}
          showToast={showToast}
          invalidData={invalidData}
          updateMyData={updateMyData}
          agreement={true}
          type="Onboarding"
        />
      )}
    </Dialog>
  );

  return dialogData;
}
